import React from 'react'
import styled from 'styled-components'
import { graphql, Link } from 'gatsby'
import Img from 'gatsby-image'
import Layout from 'components/layout'
import SEO from 'components/seo'
import media from 'styles/media'
import { ArrowButton } from 'components/Buttons'
import SupportHub from 'sections/Support/SupportHub'

const SupportPage = ({ data }) => {
  return (
    <Layout>
      <SEO title="Support" />
      <Back to="/resources">
        <ArrowButton left>Resources</ArrowButton>
      </Back>
      {/* <Image>
        <Img fluid={data.support.childImageSharp.fluid} />
      </Image> */}
      <SupportHub />
    </Layout>
  )
}

const Image = styled.div`
  width: 984px;
  margin: 192px auto 120px;
  @media screen and (max-width: 1375px) {
    width: 732px;
  }
  ${media.tabletLandscape} {
    margin-top: 48px;
  }
  ${media.mobile} {
    width: calc(100% - 24px);
    margin-left: 12px;
  }
`
const Back = styled(Link)`
  position: absolute;
  left: 96px;
  top: 192px;
  button {
    padding: 0;
    font-weight: 500;
    transition-timing-function: cubic-bezier(0.72, 0, 0.12, 1);
    transition: 0.4s;
    ::after {
      transition-timing-function: cubic-bezier(0.72, 0, 0.12, 1);
      transition: 0.4s;
    }
    :hover {
      margin-left: -4px;
      ::after {
        transition-timing-function: cubic-bezier(0.72, 0, 0.12, 1);
      }
    }
  }
  ${media.tabletLandscape} {
    display: none;
  }
`
export const pageQuery = graphql`
  query {
    support: file(relativePath: { eq: "support.jpg" }) {
      ...fluidImage
    }
  }
`
export default SupportPage
